import React from 'react';
import { Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import StopItem from './StopItemComponent';
import { getInfoForRouteData } from '../helper';
import { PROP_TYPES } from '../constants';

export default function RouteCard({ data, color, onStopClicked, maxDuration }) {
  const dataInfo = getInfoForRouteData(data);
  return (
    <Grid.Column>
      <Grid>
        {dataInfo && <div style={{ textAlign: 'center', marginTop: '16px' }}>{dataInfo}</div>}
        {data &&
          data.stops &&
          data.stops.length > 0 &&
          data.stops.map((stop, index) => (
            <StopItem
              maxDuration={maxDuration}
              onStopClicked={onStopClicked}
              stopIndex={index}
              key={stop.stopId}
              stopDetails={stop}
              color={color}
            />
          ))}
      </Grid>
    </Grid.Column>
  );
}

RouteCard.propTypes = {
  data: PROP_TYPES.ROUTE_DATA.isRequired,
  color: PropTypes.string.isRequired,
  onStopClicked: PropTypes.func.isRequired,
  maxDuration: PropTypes.number,
};

RouteCard.defaultProps = {
  maxDuration: null,
};
